import { ProjectConfig } from '@tangilla/tg-ng-models';

export const PROJECT_CONFIG: ProjectConfig = {
  auth: {
    authenticationType: 'tangilla',
    showTangillaHelp: false,
    useOnlinePortalConfig: true,
    saveUrlOnMaintenanceRedirect: true
  },
  firstPage: 'home',
  applicationName: 'tangilla_forms'
};
